import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './noMatchPage.module.css';

const NoMatchPage = () => {
  useEffect(() => {
    document.title = 'KNOW - 404 Page Not Found';
  }, []);

  return (
    <>
      <h3 id="not-found">404 - PAGE NOT FOUND</h3>
      <p>Maybe a page or link has been moved</p>
      <div id="return-home-container">
        <Link to="/" id="return-home-link">
          RETURN TO HOME PAGE
        </Link>
      </div>
    </>
  );
};

export default NoMatchPage;
